import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./styles/motion.css";
import "./App.css";
import "./lib/i18n";

// Layout global
import PublicLayout from "./components/layout/public/PublicLayout";
import AdminLayout from "./components/layout/admin/AdminLayout";
import AdminArticles from "./features/admin/AdminArticles";
import AdminCategories from "./features/admin/AdminCategories";
import AdminNewArticle from "./features/admin/AdminNewArticle";
import AdminEditArticle from "./features/admin/AdminEditArticle";

// Features - Páginas / Vistas
import About from "./features/about/About";
import Careers from "./features/careers/Careers";
import Contact from "./features/contact/Contact";
import Services from "./features/services/Services";
import HomePage from "./features/home/HomePage";
import Blog from "./features/blog/Blog";
import ArticleDetail from "./features/blog/ArticleDetail";

// Features - Servicios de negocio
import Migracion from "./features/migracion/Migracion";
import Desarrollo from "./features/desarrollo/Desarrollo";
import Consultoria from "./features/consultoria/Consultoria";
import Data from "./features/data/Data";
import Digitalizacion from "./features/digitalizacion/Digitalizacion";
import Incident from "./features/incident/Incident";
import IA from "./features/ia/IA";
import StaffAugmentation from "./features/staff-augmentation/StaffAugmentation";
import NotFound from "./features/error/NotFound";
import { AdminLogin } from "./features/admin";
import UsuariosBackoffice from "./features/admin/UsuariosBackoffice";

// Dependencias
import { INTRANET_URL } from "./config/constants";
import GlobalSnackbar from "./components/ui/FeedbackSnackbar";
import { FeedbackProvider } from "./features/admin/hooks/FeedbackContext";
import ScrollToTopButton from "./components/ui/ScrollToTopButton";

import { HelmetProvider } from "react-helmet-async";
const SHOW_BLOG = process.env.REACT_APP_SHOW_BLOG === "true";


// Componente que maneja la salida
const ExternalRedirect = () => {
  useEffect(() => {
    window.location.href = INTRANET_URL;
  }, []);

  return <p>Redirigiendo a la Intranet...</p>;
};

// Componente intermedio para usar useLocation
function AppContent() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/servicios" element={<Services />} />
        <Route path="/equipos-especializados" element={<StaffAugmentation />} />
        <Route path="/postulate" element={<Careers />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/empresa" element={<About />} />
        <Route path="/blog" element={ SHOW_BLOG ? <Blog /> : <NotFound />} />
        <Route path="/blog/:id" element={ SHOW_BLOG ? <ArticleDetail /> : <NotFound />} />
        <Route path="/cgintranet" element={<ExternalRedirect />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<HomePage />} />
      </Route>

      {/* Rutas de Administración */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="articulos" replace />} />
        <Route path="categorias" element={<AdminCategories />} />
        <Route path="articulos" element={<AdminArticles />} />
        <Route path="articulos/new" element={<AdminNewArticle />} />
        <Route path="articulos/edit/:id" element={<AdminEditArticle />} />
        <Route path="mensajes" element={<div>Gestión de Mensajes</div>} />
        <Route path="usuarios" element={<UsuariosBackoffice />} />
        <Route path="usuarios/new" element={<UsuariosBackoffice />} />
        <Route path="usuarios/edit/:id" element={<UsuariosBackoffice />} />
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <FeedbackProvider>
          <AppContent />
          <GlobalSnackbar />
          <ScrollToTopButton />
        </FeedbackProvider>
      </Router>
    </HelmetProvider>
  );
}
